import api from './api';

/**
 *
 * @returns {Promise<{
 *  assets: {
 *      asset_id: string
 *      updated_at: string
 *      task_ids: array
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#/export-assets
 */
export default async function selectedAssetData(selectedIds, module) {
    const { data } = await api.post('export-assets', {
            assetIds: selectedIds,
            model_name: module
        });
    return data;
}